var handleError = function (err) {
    console.log(err);
    return new Response(JSON.stringify({
      code: 400,
      message: 'Stupid network Error'
    }));
  };

/**
 * Gets and returns a geom from OS Mastermap data based on an xy.
 */
export default function getGeomFromCoords(x,y, unionEnabled, currentGeom, sDispatch) {

    const abortController = new AbortController();

      const request = {
        x: x,
        y: y,
        union: unionEnabled,
        geom: currentGeom
      }
      //console.log("getGeomFromCoords request: ", JSON.stringify(request));
      let mounted = true;
      (async () => {
        const res = await fetch(process.env.REACT_APP_FIND_API+'/mapping/capture', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(request),
          signal: abortController.signal,
        });
        const data = await res.json();
        if (mounted) {
          if (data.status === "success"){
            const response = {};
            response.geometry = data.geom;
            sDispatch({
              type: "setdbannotation",
              payload: { annotations: response }
            });
          }
        }
        const cleanup = () => {
          mounted = false;
          abortController.abort();
        };
        return cleanup;
      })();
}